<template>
  <v-container id="step-component" pa-0>
    <v-img
      :src="brickBackground"
      height="100%"
      position="top center"
      v-touch:swipe="swipe"
      v-touch:tap="tapHandler"
    >
      <bulletin-component v-if="step.viewType === 1" :step="step" />
      <quiz-modal v-if="step.viewType === 2" :step="step"></quiz-modal>
      <directions-modal
        v-if="step.viewType === 3"
        :step="step"
      ></directions-modal>
      <interrogate-modal
        v-if="step.viewType === 5"
        :step="step"
        type="interrogate"
      />
      <interrogate-modal
        v-if="step.viewType === 8"
        :step="step"
        type="stopandeat"
      />
      <director-bulletin
        v-if="step.viewType === 7"
        :step="step"
        :currentDialogIndex="currentDialogIndex"
      />
      <video-component v-if="step.viewType === 10" :step="step" />
      <dialog-component
        v-if="step.viewType === 4"
        :step="step"
        :currentDialogIndex="currentDialogIndex"
        :forward="forward"
      />
      <tour-intro-component v-if="step.viewType === 6" :step="step" />
      <final-lineup v-if="step.viewType === 9" :step="step" />
    </v-img>
  </v-container>
</template>

<script>
import Store from "@/store";
import questionImage from "@/assets/questionmark-avatar.jpg";
import QuizModal from "@/components/Step/QuizComponent";
import FinalLineup from "@/components/Step/FinalLineup";
import DirectionsModal from "@/components/Step/DirectionsComponent";
import InterrogateModal from "@/components/Step/InterrogateComponent";
import DirectorBulletin from "@/components/Step/directorBulletinComponent";
import Bulletin from "@/components/Step/bulletin.vue";
import TourIntroComponent from "@/components/Step/TourIntroComponent";
import DialogComponent from "@/components/Step/dialogComponent";
import VideoComponent from "@/components/Step/videoSlideComponent";
import brickBackground from "@/assets/backgrounds/brick-blk.png";
import { copyFileSync } from "fs";
//import brickAnimated from '@/assets/backgrounds/background-animation.gif'
import seasonalBackground from "@/assets/backgrounds/Christmasbrick-blk.png";

export default {
  name: "step-component",
  props: {
    step: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    "quiz-modal": QuizModal,
    "directions-modal": DirectionsModal,
    "interrogate-modal": InterrogateModal,
    "director-bulletin": DirectorBulletin,
    "dialog-component": DialogComponent,
    "tour-intro-component": TourIntroComponent,
    "bulletin-component": Bulletin,
    "final-lineup": FinalLineup,
    "video-component": VideoComponent,
  },
  data() {
    return {
      answerDialog: true,
      incorrectDialog: false,
      correctDialog: false,
      helpDialog: false,
      hintDialog: false,
      openHintIndex: null,
      userInput: "",
      questionMarkUrl: questionImage,
      swipeDirection: "None",
      currentStep: this.step,
      brickBackground,
      seasonalBackground,
      currentDialogIndex: 0,
      forward: true,
    };
  },
  methods: {
    goBack() {
      this.$store.dispatch("decrementStep");
    },
    goForward() {
      this.$store.dispatch("incrementStep");
    },
    getCurrentStep() {
      return this.$store.getters.currentStep;
    },
    fullscreenTapHandler(xTap, xHalf) {
      if (xTap > xHalf) {
        if (this.dialogComponent) {
          if (this.currentDialogIndex + 1 === this.numOfDialogViews) {
            this.currentDialogIndex = 0;
            this.$store.dispatch("setDialog", this.currentDialogIndex);
            this.goForward();
          } else {
            this.forward = true;
            this.$store.dispatch("setDialog", this.currentDialogIndex + 1);
            this.currentDialogIndex += 1;
          }
        } else {
          this.goForward();
        }
      } else {
        if (this.dialogComponent) {
          if (this.currentDialogIndex === 0) {
            this.goBack();
          } else {
            this.forward = false;
            this.$store.dispatch("setDialog", this.currentDialogIndex - 1);
            this.currentDialogIndex -= 1;
          }
        } else {
          this.goBack();
        }
      }
    },
    halfscreenTapHandler(xTap, yTap, xHalf, yHalf) {
      console.log("no");
    },
    tapHandler(e, b) {
      e.preventDefault();

      const xHalfwaypoint = Math.floor(this.$store.getters.appInnerWidth / 2);
      const swipeXPoint = Math.floor(e.changedTouches[0].pageX);
      if (this.step.viewType === 15) {
        const yHalfwayPoint = Math.floor(window.innerHeight / 2);
        const swipeYPoint = Math.floor(e.changedTouches[0].pageX);
        this.halfscreenTapHandler(
          swipeXPoint,
          swipeYPoint,
          xHalfwaypoint,
          yHalfwayPoint
        );
        return;
      } else {
        this.fullscreenTapHandler(swipeXPoint, xHalfwaypoint);
        return;
      }
    },
    swipeHandler(e) {},
    swipe(direction) {
      switch (direction) {
        case "right":
          if (this.dialogComponent) {
            if (this.currentDialogIndex === 0) {
              this.goBack();
            } else {
              this.forward = false;
              this.$store.dispatch("setDialog", this.currentDialogIndex - 1);
              this.currentDialogIndex -= 1;
            }
          } else {
            this.goBack();
          }
          break;
        case "left":
          if (this.dialogComponent) {
            if (this.currentDialogIndex + 1 === this.numOfDialogViews) {
              this.currentDialogIndex = 0;
              this.$store.dispatch("setDialog", this.currentDialogIndex);
              this.goForward();
            } else {
              this.forward = true;
              this.$store.dispatch("setDialog", this.currentDialogIndex + 1);
              this.currentDialogIndex += 1;
            }
          } else {
            this.goForward();
          }
          break;
      }
    },
  },
  computed: {
    dialogComponent() {
      return this.step.viewType === 4 || this.step.viewType === 7;
    },
    numOfDialogViews() {
      return this.step.dialogUrls ? this.step.dialogUrls.length : null;
    },
    backgroundImage() {
      switch (this.step.viewType) {
        case 1:
          return this.brickBackground;
          break;
        case 2:
          return this.brickBackground;
          break;
        case 3:
          return this.brickBackground;
          break;
        case 4:
          return this.brickBackground;
          break;
        case 5:
          return this.brickBackground;
          break;
        case 6:
          return this.brickBackground;
          break;
        case 7:
          return this.brickBackground;
          break;
        case 10:
          return this.brickBackground;
          break;
      }
    },
    currentStepObject() {
      return this.getCurrentStep();
    },
    imageClass() {
      return {
        "max-height": "100%",
        width: "auto",
        "max-width": "85%",
        margin: "auto auto",
      };
    },
  },
};
</script>

<style scoped>
#bulletin-container {
  height: 90%;
}

#step-component {
  position: absolute;
  bottom: 85px;
  top: 0;
  right: 0;
  left: 0;
}

.tour-slider-container {
  position: absolute;
  top: 110px;
  bottom: 0px;
}

.page-enter-active,
.page-leave-active {
  transition: opacity 1s, transform 1s;
}

.page-enter,
.page-leave-to {
  opacity: 0;
  transform: translateX(-30%);
}
</style>
